import { RootState } from '../root';

export const selectIsLoading = (state: RootState) => state.push.loading;

export const selectPushError = (state: RootState) => state.push.error;

export const selectPushHasUnsavedChanges = (state: RootState) =>
    state.push.pushHasUnsavedChanges;
